import React, { createElement, Component } from 'react';
import {
  Title,
  Subtitle,
  Content,
  Container,
  IconWarning,
  Button
} from './style';
import { Warning } from '../../../../assets/images';

const ErrorComponent = ({ error, title, onToggle, show, debug }) => (
  <div>
    <Title>¡Hubo un error!</Title>
    {debug ? (
      <div>
        <Subtitle>{title}</Subtitle>
        <Button onClick={onToggle}>{show ? 'Ver menos' : 'Ver más'}</Button>
        <Container active={show}>
          <IconWarning svg={Warning} alt="Warning" color="error" />
          <Content dangerouslySetInnerHTML={{ __html: error }} />
        </Container>
      </div>
    ) : (
      false
    )}
  </div>
);

const withErrors = (input = {}) => BaseComponent => {
  // createElement devuelve un elemento, no una funcion: se envuelve para
  // conservar el contrato factory(props) que espera render() (antes createFactory)
  const factory = props => createElement(BaseComponent, props);

  class withErrorClass extends Component {
    constructor() {
      super();

      this.state = {
        hasError: false,
        errorInfo: null,
        showInfo: false,
        debug: Object.prototype.hasOwnProperty.call(input, 'debug')
          ? input.debug
          : process.env.NODE_ENV === 'development'
      };
    }

    onToggle = () => {
      this.setState(prevState => ({
        showInfo: !prevState.showInfo
      }));
    };

    componentDidCatch(error) {
      console.error(error);

      this.setState({
        hasError: true,
        errorTitle: `${error.name}: ${error.message}`,
        errorInfo: error.stack.replace(/(?:\r\n|\r|\n)/g, '<br />')
      });
    }

    render() {
      const { errorTitle, errorInfo, showInfo, debug } = this.state;

      if (this.state.hasError) {
        return (
          <ErrorComponent
            title={errorTitle}
            error={errorInfo}
            show={showInfo}
            onToggle={this.onToggle}
            debug={debug}
          />
        );
      }
      return factory({
        ...this.props,
        ...this.handlers
      });
    }
  }

  return withErrorClass;
};

export default withErrors;
